import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { ConfigContext } from "../Context/ConfigContext";

const StoreSelect = ({ storeId, setStoreId, disabled = false, placeholder = 'Select a Store' }) => {
    const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
    const [stores, setStores] = useState([]);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const response = await axios.get(`${apiUrl}/Masters/GetStoreList`, { headers: apiHeadersJson });
                setStores(response.data.data || []);
            } catch (error) {
                console.error("Error fetching stores:", error);
            }
        };

        fetchStores();
    }, [apiUrl, apiHeadersJson]);

    return (
        <select
            className="form-select"
            value={storeId || ''}
            disabled={disabled}
            onChange={(e) => setStoreId(e.target.value)}
        >
            <option value="" disabled>{placeholder}</option>
            {stores.map((store) => (
                <option key={store.store_id} value={store.store_id}>
                    {store.store_name}
                </option>
            ))}
        </select>
    );
};

export default StoreSelect;
